/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FunctionResult,
  PostLoginRequest,
} from '../models/index';
import {
    FunctionResultFromJSON,
    FunctionResultToJSON,
    PostLoginRequestFromJSON,
    PostLoginRequestToJSON,
} from '../models/index';

export interface PostFunctionRequest {
    postLoginRequest?: PostLoginRequest;
}

/**
 * 
 */
export class FunctionApi extends runtime.BaseAPI {

    /**
     * 
     * 利用可能機能を取得する
     */
    async postFunctionRaw(requestParameters: PostFunctionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/function`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLoginRequestToJSON(requestParameters['postLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionResultFromJSON(jsonValue));
    }

    /**
     * 
     * 利用可能機能を取得する
     */
    async postFunction(requestParameters: PostFunctionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionResult> {
        const response = await this.postFunctionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
